/* tslint:disable */

declare var Object: any;
export interface SMSServiceInterface {
  "id"?: number;
}

export class SMSService implements SMSServiceInterface {
  "id": number;
  constructor(data?: SMSServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SMSService`.
   */
  public static getModelName() {
    return "SMSService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SMSService for dynamic purposes.
  **/
  public static factory(data: SMSServiceInterface): SMSService{
    return new SMSService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SMSService',
      plural: 'SMSServices',
      path: 'SMSServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
